export default __webpack_public_path__ + "static/shareIdeaArticle-b2d992573a25d5197ca05064d0102b3d.png";